// extracted by mini-css-extract-plugin
module.exports = {"button":"ProfileMenu_button__uRuqA","menuContainer":"ProfileMenu_menuContainer__WIXr0","buttonIcon":"ProfileMenu_buttonIcon__BGG9w","logoutIcon":"ProfileMenu_logoutIcon__1vrhT"};